import React from "react";
import { FormGroup, LabelForm, FormGroupVerticalInput, RadioInput } from "..";
import { getInputErrorMessage } from "../../utils";

const SearchType = ({ errors, dataSearch, setDataSearch }) => {
  const handleSetFormSearch = (e) => {
    setDataSearch({ ...dataSearch, type: e.target.value });
  };
  return (
    <>
      <FormGroup direction="horizontal">
        <LabelForm
          text="対象データ"
          required
          className="lg:min-w-[248px] min-w-[232px]"
        />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "type")}>
          <div className="flex flex-row items-center xl:space-x-10 space-x-8">
            <RadioInput
              id="inspection"
              name="type"
              value="inspection"
              label="点検履歴"
              onChange={(e) => handleSetFormSearch(e)}
              checked={dataSearch.type === "inspection"}
            />
            <RadioInput
              id="machine"
              name="type"
              value="machine"
              label="設備マスタ"
              onChange={(e) => handleSetFormSearch(e)}
              checked={dataSearch.type === "machine"}
            />
          </div>
        </FormGroupVerticalInput>
      </FormGroup>
    </>
  );
};

export default SearchType;
